import { hookstate as createState, State, useHookstate as useState } from '@hookstate/core';
import { formatMessage } from '../services/http.service';

export interface BaseState {
    isBusy: boolean;
    errorMessage?: string;
} 

class Store<T extends BaseState> {
    protected _state: State<T>

    public get state(): State<T> { return useState(this._state); }

    constructor(initialState?: Partial<T>) {
        this._state = createState(initialState as T)        
    }

    public clearMessages() {
        this._state.set(s => {
            s.errorMessage = undefined;
            return s;
        })
    }

    protected async handleCallAsync<T>(func: () => Promise<T>) {
        return await (async () => {
            try {
                this._state.set(s => { s.errorMessage = undefined; s.isBusy = true; return s; });
                return await func();
            }
            catch (ex) {
                this._state.set(s => {
                    s.errorMessage = formatMessage(ex);
                    return s;
                });
            }
            finally {
                this._state.set(s => { s.isBusy = false; return s; });
            }
        })()
    }
}

export default Store;